import { render, staticRenderFns } from "./GroupActions.vue?vue&type=template&id=6f7ae120&"
import script from "./GroupActions.vue?vue&type=script&lang=js&"
export * from "./GroupActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports